import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../Layout/Auth";
import ManageAccount from "../Pages/ManageAccount";
import ChangePassword from "../Pages/ChangePassword";


function ProfileRoute({ isLoggedIn, ...routeProps }) {
    const history = useHistory();
    return (
        <Switch>
            <Route
                exact
                path="/:lng/manage-account"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <ManageAccount isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/change-password"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <ChangePassword isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
        </Switch>
    );
}


export default ProfileRoute;
